import { setDropdownValuesType } from './ResultsPaginationConstants';
import { selectPage as selectPageHelper } from './ResultsPaginationHelper';

export function setDropdownValues(dropdownValues) {
  return {
    type: setDropdownValuesType,
    dropdownValues,
  };
}

export function selectPage(pageNumber) {
  return () => selectPageHelper(pageNumber);
}
